import React, { useState } from 'react'

function Colors() {

    const [showColor, setShowColor] = useState(false)

  return (
    <div>
        
    {showColor?
        
            <div className='color-container'>
                <p>Your records are categorized into the following areas based on the emotions you selected.</p>
                <div className='color-grid' >
                <div className='btn red' style={{"textAlign":"center"}}>😫High energy<br/>Low Pleasantness</div>
                
                <div className='btn yellow' style={{"textAlign":"center"}}>😃High Energy<br/>High Pleasantness</div>
                
                <div className='btn blue' style={{"textAlign":"center"}}>😞Low Energy<br/>Low Pleasantness</div>
        
                <div className='btn green' style={{"textAlign":"center"}}>😌Low Energy<br/>High Pleasantness</div>


                </div>
                <div className='h-list center'>
                    <button className='btn' onClick={()=>{setShowColor(false)}}>Close</button>
                </div>
                
            </div>:
            <button style={{"marginTop": "0px", "padding":"10px"}} onClick={()=>{setShowColor(true)}} className='list-container text-btn forgot'>What do the colors and emoji mean?</button>
    }
   
    </div>
  )
}

export default Colors
